import { Box, Menu, MenuItem, Link as MuiLink } from '@mui/material';
import { header_content } from '../../../../../data/general_texts';
import { useAuth } from '../../../../../contexts/AuthProvider';
import { FaChevronDown } from 'react-icons/fa6';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getPartnerNav } from '../../partnerNav';

const landingLinks = header_content.main_links;

const PartnerNavItem = ({ item, pathname }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const active = item.isActive(pathname);

    const handleClose = () => setAnchorEl(null);

    if (!item.children) {
        return (
            <MuiLink
                component={Link}
                to={item.to}
                aria-current={active ? 'page' : undefined}
                sx={{ ...styles.navLink, ...(active ? styles.navLinkActive : null) }}
            >
                {item.label}
            </MuiLink>
        );
    }

    return (
        <Box sx={{ ...styles.navItem, color: active ? 'secondary.main' : 'common.white' }}>
            <Box
                component="button"
                type="button"
                aria-haspopup="menu"
                aria-expanded={open}
                aria-current={active ? 'page' : undefined}
                onClick={(event) => setAnchorEl(open ? null : event.currentTarget)}
                sx={{
                    ...styles.navLink,
                    ...styles.navTrigger,
                    ...(active ? styles.navLinkActive : null),
                    mx: 0,
                }}
            >
                {item.label}
                <Box component="span" sx={{ ...styles.chevron, ...(open ? styles.chevronOpen : null) }}>
                    <FaChevronDown size={10} />
                </Box>
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                slotProps={{
                    paper: { sx: styles.menuPaper },
                }}
            >
                {item.children.map((child) => (
                    <MenuItem
                        key={child.to}
                        component={Link}
                        to={child.to}
                        selected={pathname.startsWith(child.to)}
                        onClick={handleClose}
                        sx={styles.menuItem}
                    >
                        {child.label}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

const NavBar = () => {
    const { isAuthenticated, user } = useAuth();
    const { pathname } = useLocation();
    const items = getPartnerNav(user);

    return (
        <Box component="nav" sx={styles.list_link} aria-label="Navegação principal">
            {isAuthenticated
                ? items.map((item) => (
                    <PartnerNavItem key={item.to} item={item} pathname={pathname} />
                ))
                : landingLinks.map((link) => (
                    <MuiLink key={link.title} href={link.link} sx={styles.navLink}>
                        {link.title}
                    </MuiLink>
                ))}
        </Box>
    );
};

const styles = {
    list_link: {
        display: {
            xs: 'none',
            md: 'flex',
        },
        justifyContent: 'center',
        alignItems: 'center',
        gap: { md: '0.5rem', lg: '0.25rem' },
        py: '1.15rem',
    },
    navItem: {
        display: 'inline-flex',
        alignItems: 'center',
        mx: { md: '0.65rem', lg: '1rem' },
    },
    navLink: {
        color: 'common.white',
        cursor: 'pointer',
        fontSize: '0.8125rem',
        fontWeight: 500,
        letterSpacing: '0.02em',
        lineHeight: 1.2,
        mx: { md: '0.65rem', lg: '1rem' },
        '&:hover': {
            color: 'secondary.main',
        },
    },
    navLinkActive: {
        color: 'secondary.main',
        fontWeight: 600,
    },
    navTrigger: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        minHeight: 44,
        px: 0.5,
        border: 0,
        background: 'transparent',
        font: 'inherit',
        color: 'inherit',
        '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'secondary.main',
            outlineOffset: 2,
        },
    },
    chevron: {
        display: 'inline-flex',
        transition: 'transform .15s ease-out',
    },
    chevronOpen: {
        transform: 'rotate(180deg)',
    },
    menuPaper: {
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        mt: 1.25,
        minWidth: 180,
        boxShadow: 2,
    },
    menuItem: {
        fontSize: '0.875rem',
        fontWeight: 500,
        py: 1,
        '&.Mui-selected': {
            bgcolor: 'transparent',
            color: 'secondary.dark',
        },
        '&.Mui-selected:hover': {
            bgcolor: 'action.hover',
        },
    },
};

export default NavBar;
